/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { Box, Grid, Paper, Tab, Tabs } from '@mui/material';

import Layout from "../../../components/layout/Layout";
import Form from "./Form";

function TabPanel({ children, value, index, ...other }) {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`invoice-client-tabpanel-${index}`}
            aria-labelledby={`invoice-client-tab-${index}`}
            {...other}
        >
            <Box key={value}>
                {value === index && children}
            </Box>
        </div>
    );
}

const Detail = () => {
    const [__] = useTranslation("invoiceClient");
    const [value, setValue] = useState(0);
    const [btns, setBtns] = useState(<></>);

    const tabs = [
        {
            label: __(`tabs.invoice`),
            component: <Form setBtns={setBtns} />,
            visible: true,
        },
    ];

    const visibleTabs = tabs.filter(tab => tab.visible);

    const handleChange = (event, newValue) => setValue(newValue);

    return (
        <Layout
            propsToolbar={{
                title: __(`head.edit.name`),
                srute: __(`head.edit.code`),
            }}
        >
            <Box display="block">
                <Box className="ml-4 mr-0">
                    <Grid className="py-2" container component={Paper} spacing={2}>
                        <Grid item xs={12} lg={6}>
                            <Tabs
                                value={value}
                                onChange={handleChange}
                                variant="scrollable"
                                scrollButtons
                                allowScrollButtonsMobile
                            >
                                {visibleTabs.map((tab, index) => (
                                    <Tab key={index} label={tab.label} />
                                ))}
                            </Tabs>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            {btns}
                        </Grid>
                    </Grid>
                </Box>
                {visibleTabs.map((tab, index) => (
                    <TabPanel key={index} value={value} index={index}>
                        {tab.component}
                    </TabPanel>
                ))}
            </Box>
        </Layout>
    );
};

export default Detail;
